import type * as api from '@gitbook/api-client';
import { Button, DialogTrigger, type OverlayTriggerState } from '@gitbook/spine-react';

/**
 * Button to add create a space.
 */
export function SpaceCreateButton(props: {
    organization: api.Organization;
    trigger: OverlayTriggerState;
}) {
    const { organization, trigger } = props;
    const buttonProps = { label: 'Create space' };
    if (!organization.permissions.createContent) {
        return (
            <Button
                {...buttonProps}
                disabled
                tooltip={{
                    label: "You do not have permission to create a space. Reach out to your organization's admin to get started.",
                }}
            />
        );
    }
    return (
        <DialogTrigger trigger={trigger}>
            <Button {...buttonProps} />
        </DialogTrigger>
    );
}
